import { types, Instance, getRoot, getSnapshot } from 'mobx-state-tree'
import {
  configuration,
  cover,
  adapter,
  accessoryConnection,
  fastenerConnection,
  componentSide
} from 'src/constants/typenames'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { View } from 'src/api/misc/View'
import { Padding } from 'src/api/misc/View/Padding'
import { stepLinks, stepsConfiguration } from 'src/constants/configuration'
import { orbit } from 'src/constants/sides'
import { IRoot } from '../Root/types'
import { Layers } from 'src/api/misc/Layers'
import { PerceptionStore } from 'src/api/misc/Perception/PerceptionStore'
import { generateNodeId } from 'src/api/models/Node/ID'
import { genereateNodeTypename } from 'src/api/models/Node/Typename'
import { RouteState } from 'src/constants/routes'

/**
 *
 *
 *
 */

const Step = types.compose(
  types.model('Step', {
    route: types.identifier,
    layers: types.optional(Layers, {})
  }),
  PerceptionStore
)

const steps = stepLinks('')
  .map(path => (path.startsWith('/') ? path.substring(1) : path))
  .reduce((p, route) => ({ ...p, [route]: { route } }), {})

export const Configuration = View.named(configuration)
  .props({
    id: generateNodeId(configuration),
    __typename: genereateNodeTypename(configuration),
    steps: types.optional(types.map(Step), stepsConfiguration),
    padding: types.optional(Padding, { top: 0, right: 320, bottom: 0, left: 0 })
  })
  .views(self => ({
    get currentStep() {
      const root = getRoot<Instance<IRoot>>(self)
      if (root.routeState?.state?.step !== undefined) {
        return self.steps.get(root.routeState.state.step)
      }
      return undefined
    }
  }))
  .views(self => ({
    get layers() {
      return self.currentStep?.layers && getSnapshot(self.currentStep.layers)
    }
  }))
  .views(self => ({
    // get routePerceptions() {
    //   return { [cover]: { visible: false }, [adapter]: { visible: false } }
    // },
    getPerceptions(state: RouteState['state']) {
      if (state && state.step) {
        return self.steps.get(state.step)?.perceptions
      }
    },
    get perceptions() {
      // const map = new Map()
      // map.set(accessoryConnection, { visible: false })
      // map.set(fastenerConnection, { visible: false })
      // map.set('CoverPlateEdge', {
      //   selector: '/properties/side',
      //   ...['front', 'top', 'right', 'left', 'back'].reduce(
      //     (p, c) => ({ ...p, [c]: { visible: false } }),
      //     {}
      //   )
      // })
      // map.set('AdapterPlateEdge', {
      //   selector: '/properties/side',
      //   ...['front', 'top', 'right', 'left', 'back'].reduce(
      //     (p, c) => ({ ...p, [c]: { visible: false } }),
      //     {}
      //   )
      // })
      // map.set('GapSide', {
      //   selector: 'side',
      //   ...['top', 'right', 'bottom', 'left', 'back'].reduce(
      //     (p, c) => ({ ...p, [c]: { visible: false } }),
      //     {}
      //   )
      // })
      // map.set('Gap', { visible: false })
      // map.set(componentSide, { fill: { color: 'red' }, line: {} })

      const root = getRoot<Instance<IRoot>>(self)
      if (root.routeState?.state?.step !== undefined) {
        const { step, subStep = undefined } = root.routeState?.state
        return self.steps.get(`${step}${subStep ? `/${subStep}` : ''}`)?.perceptions
      }
    }
  }))
  .actions(self => ({
    afterAttach() {
      console.log(self.steps)
    }
  }))

// .actions(self => ({ switchSide: undefined }))
// .actions(self => {
//   const currentStepIndex = self.steps.findIndex(
//     (step: Instance<typeof Step>) => step.route === self.currentStep.route
//   )
//   return {
//     next() {
//       if (currentStepIndex + 1 < self.steps.length) {
//         self.currentStep = self.steps[currentStepIndex + 1]
//       } else if (currentStepIndex + 1 === self.steps.length) {
//       }
//     },
//     back() {
//       if (currentStepIndex === 0) {
//       }
//     }
//   }
// })
